var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2B9BC7;}\r\ng{\r\n\ttransform: scale(2.5) translate(-30%, -30%);\r\n}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M405,456.2c3,2.7,4.6,4,6.1,5.4c31,29.3,62.1,58.6,93,87.9c21.8,20.6,49.8,20.8,71.6,0.4 c31.3-29.3,62.5-58.7,93.8-88c1.3-1.3,2.7-2.5,5.3-4.9c1.2,5.1,3.1,9.2,3.1,13.4c0.2,46.8,0.3,93.5,0,140.3 c-0.1,15.9-13.4,28.1-29.9,28.2c-27.9,0.1-55.8,0-83.7,0c-43.3,0-86.6,0-129.8,0c-20.1,0-32.3-12.1-32.3-32 c0-44.5-0.1-89,0.1-133.5C402.2,468.1,403.8,462.9,405,456.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M659.9,446c-1.8,1-3.9,1.6-5.4,2.9c-30.7,28.7-61.3,57.6-91.9,86.3c-14.7,13.8-30.5,13.7-45.2-0.1 c-30.9-29.1-61.7-58.3-92.6-87.4c-1-1-1.9-2-3.8-4.1c4.2-0.6,7.5-1.6,10.8-1.6c72.2-0.1,144.4-0.1,216.6,0c3.3,0,6.6,1,10,1.5 C658.8,444.3,659.4,445.2,659.9,446z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.7037eb39520cb00092bf8b038d125c37.svg";
export { ForwardRef as ReactComponent };